import { render, staticRenderFns } from "./交易项目详情_自由竞价版本_socket.vue?vue&type=template&id=2073648d&scoped=true"
import script from "./交易项目详情_自由竞价版本_socket.vue?vue&type=script&lang=js"
export * from "./交易项目详情_自由竞价版本_socket.vue?vue&type=script&lang=js"
import style0 from "./交易项目详情_自由竞价版本_socket.vue?vue&type=style&index=0&id=2073648d&prod&lang=css"
import style1 from "./交易项目详情_自由竞价版本_socket.vue?vue&type=style&index=1&id=2073648d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073648d",
  null
  
)

export default component.exports